import { enableBodyScroll } from 'body-scroll-lock';

document.addEventListener('DOMContentLoaded', () => {
    const $container = document.querySelector('.law');
    const $toggleBtn = document.querySelector('.btn-aside-mobile');
    if (!$container) return;

    const $navList = document.querySelector('.content-aside-nav');
    if (!$navList) return;

    const $nav = document.querySelector('.content-aside');
    if (!$nav) return;

    const headings = document.querySelectorAll('.art-section .accordion-title');
    headings.forEach((heading) => {
        const parentWithId = heading.closest('[id]');
        if (!parentWithId) return;

        const textOnly = Array.from(heading.childNodes)
            .filter((node) => node.nodeType === Node.TEXT_NODE)
            .map((node) => node.textContent.trim())
            .join(' ')
            .trim();

        if (!textOnly) return;

        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${parentWithId.id}`;
        link.textContent = textOnly;

        li.appendChild(link);
        $navList.appendChild(li);

        link.addEventListener('click', () => {
            if (window.innerWidth <= 768) {
                $nav.classList.remove('active');
                $toggleBtn.setAttribute('aria-expanded', 'false');
                enableBodyScroll($nav);
            }
        });
    });
});
